/* eslint eqeqeq: "off" */
import * as React from 'react';
import {connect} from 'react-redux';
import {
    setTimeShow,
    handleNextStep,
    handleStepBack,
    setFNOLDrivable,
    setStep,
    setFNOLLocation,
    setHasSmashAndGrab,
    setCanBeenRepaired,
    setRepairStepValid,
    setFnolReducerPayload
} from '../../../actions/claimSubmitActions';
import {isMobile} from 'react-device-detect';
import {FNOL_CLAIM_PROGRESS_MOBILE} from '../../../routes/routes';
import {navigateTo} from '../../../actions/navigationActions';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import PlacesAutocomplete, {geocodeByAddress, getLatLng,} from 'react-places-autocomplete';
import {Dropdown} from 'react-bootstrap';
import './Glass.css';
import {postToController} from '../../../actions/apiActions';
import {SET_CLAIM_DATA} from '../../../constants/constants';
import Geocode from "react-geocode";

var lat = 0
var lng = 0

class GlassRepairsNo extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            adressSelect: this.props.claimSubmit.adress,
            lat: this.props.claimSubmit.addressLat,
            lng: this.props.claimSubmit.addressLon,
            isRepaired: "",
            optionValue: "",
            isInstalled: "",
            glassDamageList: [{id: 1, description: "Chip"},
                {id: 2, description: "Shattered"},
                {id: 3, description: "Chip bigger than R2 coin"},
                {id: 4, description: "Crack"}
            ],
            glassDamageDescription: "",
            glassDamageReplace: false,
            addressDetail: {province: "", city: "", suburb: "", formatted: "", postalCode: ""}
        };
        this.handleIsRepaired = this.handleIsRepaired.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleAdressChange = this.handleAdressChange.bind(this);
        this.handleAdressSelect = this.handleAdressSelect.bind(this);
        this.updateLatLngAdress = this.updateLatLngAdress.bind(this);
        this.mapReady = this.mapReady.bind(this);
        this.getGlassDamages = this.getGlassDamages.bind(this);

        this.handleGlassDamage = this.handleGlassDamage.bind(this);
        this.setSmashAndGrab = this.setSmashAndGrab.bind(this);
        this.checkRepairsValid = this.checkRepairsValid.bind(this);
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        Geocode.setApiKey("AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8");
        this.checkRepairsValid();
    }

    handleIsRepaired(isRepaired) {
        this.setState({isRepaired: isRepaired, optionValue: ""});
    }

    async handleOnChange(e) {
        this.setState({optionValue: e.target.value});
    }

    handleAdressChange = address => {
        this.setState({adressSelect: address});
    };

    handleAdressSelect = address => {
        let addressDetails = {province: "", city: "", suburb: "", formatted: "", postalCode: ""}
        geocodeByAddress(address)
            .then(async (results) => {
                let latlong = await getLatLng(results[0]);
                let streetNumber, streetName, suburb, city, state, country, postal_code;
                const address = results[0];
                for (let i = 0; i < address.address_components.length; i++) {
                    for (let j = 0; j < address.address_components[i].types.length; j++) {
                        switch (address.address_components[i].types[j]) {
                            case "street_number":
                                streetNumber = address.address_components[i].long_name;
                                break;
                            case "route":
                                streetName = address.address_components[i].long_name;
                                break;
                            case "sublocality":
                                suburb = address.address_components[i].long_name;
                                break;
                            case "locality":
                                city = address.address_components[i].long_name;
                                break;
                            case "administrative_area_level_1":
                                state = address.address_components[i].long_name;
                                break;
                            case "country":
                                country = address.address_components[i].long_name;
                                break;
                            case "postal_code":
                                postal_code = address.address_components[i].long_name;
                                break;
                        }
                    }
                }
                addressDetails = {
                    province: state?.toUpperCase(),
                    city: city?.toUpperCase(),
                    suburb: suburb?.toUpperCase(),
                    formatted: address.formatted_address,
                    postalCode: postal_code?.toUpperCase()
                }
                this.setState({
                    lat: latlong.lat,
                    lng: latlong.lng,
                    addressSelect: address,
                    addressDetail: addressDetails
                });
                this.updateLatLngAdress(latlong.lat, latlong.lng, address, addressDetails);
                this.checkRepairsValid();
            })
    };

    async updateLatLngAdress(Lat, Lng, address, addressDetails) {
        lat = Lat
        lng = Lng

        await this.setState({ lat: Lat, lng: Lng, adressSelect: addressDetails.formatted, addressDetail: addressDetails });
        this.props.dispatchAction(setFnolReducerPayload({
            addressLat: Lat,
            addressLon: Lng,
            addressDetail: addressDetails
        }));
    };


    async mapReady(mapProps, map) {
        let lat = map.center.lat();
        let lng = map.center.lng();
        await this.setState({lat: lat, lng: lng})
        map.addListener("click", (mapsMouseEvent) => {
            lat = mapsMouseEvent.latLng.toJSON().lat
            lng = mapsMouseEvent.latLng.toJSON().lng
            Geocode.fromLatLng(lat, lng).then(
                (response) => {
                    let streetNumber, streetName, suburb, city, state, country, postal_code;
                    const address = response.results[0];
                    for (let i = 0; i < address.address_components.length; i++) {
                        for (let j = 0; j < address.address_components[i].types.length; j++) {
                            switch (address.address_components[i].types[j]) {
                                case "street_number":
                                    streetNumber = address.address_components[i].long_name;
                                    break;
                                case "route":
                                    streetName = address.address_components[i].long_name;
                                    break;
                                case "sublocality":
                                    suburb = address.address_components[i].long_name;
                                    break;
                                case "locality":
                                    city = address.address_components[i].long_name;
                                    break;
                                case "administrative_area_level_1":
                                    state = address.address_components[i].long_name;
                                    break;
                                case "country":
                                    country = address.address_components[i].long_name;
                                    break;
                                case "postal_code":
                                    postal_code = address.address_components[i].long_name;
                                    break;
                            }
                        }
                    }

                    let addressDetails = { province: state?.toUpperCase(), city: city?.toUpperCase(), suburb: suburb?.toUpperCase(), formatted: address.formatted_address, postalCode: postal_code?.toUpperCase() };
                    this.setState({ lat: lat, lng: lng, addressSelect: address.formatted_address, addressDetail: addressDetails });
                    this.updateLatLngAdress(lat, lng, address, addressDetails);
                })
        })
    }

    handleGlassDamage(e: any) {
        /* eslint eqeqeq: "off" */
        let glassDamage = this.state.glassDamageList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        this.setState({
            glassDamageDescription: glassDamage[0].description,
            glassDamageReplace: e === 1 ? true : false
        });
        this.props.dispatchSetCanBeenRepaired(e === '1' ? true : false)
        this.checkRepairsValid();
    }

    async handleSmashAndGrab(e) {
        /* eslint eqeqeq: "off" */
        let glassDamage = this.state.glassDamageList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        await this.setState({
            glassDamageDescription: glassDamage[0].description,
            glassDamageReplace: e === 1 ? false : true
        });
        this.checkRepairsValid();
    }

    async getGlassDamages() {
        await postToController(this.props.dispatch, 'GetGlassDamageList', JSON.stringify({})).then(async (response) => {
            await this.setState({glassDamageList: response});
            return true;
        })
    }

    async setSmashAndGrab(e: any) {
        let answer = e.target.value
        await this.setState({
            isInstalled: answer,
        });

        if (answer === "yes") {
            this.props.dispatchSetHasSmashAndGrab(true)
        } else {
            this.props.dispatchSetHasSmashAndGrab(false)
        }
        this.checkRepairsValid();
    }

    async checkRepairsValid() {
        if (this.state.isInstalled !== '' && this.state.glassDamageDescription !== '' && this.state.adressSelect) {
            this.props.dispatchSetRepairStepValid(true);
        } else {
            this.props.dispatchSetRepairStepValid(false);
        }
    }

    public render() {
        const countryFilter = this.props.profile.countryId === 157 ? "NA" : "ZA"
        let glassDamageDrop = [];
        if (this.state.glassDamageList.length > 0) {
            glassDamageDrop = this.state.glassDamageList.map((item) => {
                return <Dropdown.Item eventKey={item.id} key={item.id}
                                      vlaue={item.id === 1 ? true : false}>{item.description}</Dropdown.Item>
            });
        }
        return (
            <>
                <div className="row noma glassclaims-parent-row mt-19px">
                    <div className="col nopa">
                        <p className="text-16 glassclaims-intro-p"><b>Do you have smash and grab installed on any of the
                            damaged glass</b></p>
                    </div>
                    <div className="nopa text-lg-right glassclaims-button-col">
                        <div className="row noma glassclaims-button-row">
                            <div className="col nopa glassclaims-button-no">
                                <button
                                    className={this.state.isInstalled === "no" ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"}
                                    value="no" onClick={this.setSmashAndGrab}>No
                                </button>
                            </div>
                            <div className="glassclaims-mobile-gutter nopa"></div>
                            <div className="col nopa glassclaims-button-yes">
                                <button
                                    className={this.state.isInstalled === "yes" ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"}
                                    value="yes" onClick={this.setSmashAndGrab}>Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="mt-19px mb-0px glassclaims-hr-2px"/>
                <div className="row noma mb-23px glass-repairs-location-p">
                    <div
                        className={!this.state.glassDamageDescription ? "col-12 nopa mt-19px mb-21px" : "col-12 nopa mb-21px"}>
                        <div className="fnol-glassclaims-incident-type-selector-holder ssp-form">
                            <Dropdown id="ChooseDamageToGlass" className="ssp-dropdown ssp-dropdown-item-list-no-images"
                                      onSelect={this.handleGlassDamage}>
                                <Dropdown.Toggle id="dropdown-basic" className="ssp-dropdown-select-button">
                                    {this.state.glassDamageDescription &&
                                        <>
                                            <div className="row ssp-dropdown-select-row">
                                                <div className="col">
                                                    <span
                                                        className="ssp-dropdown-select-choose-text-selected-product"></span>
                                                    <span
                                                        className="ssp-dropdown-select-selected-product">{this.state.glassDamageDescription}</span>
                                                </div>
                                                <div className="ssp-dropdown-icon mt-19px"></div>
                                            </div>
                                        </>
                                    }
                                    {!this.state.glassDamageDescription &&
                                        <div className="row ssp-dropdown-select-row">
                                            <div className="col ssp-dropdown-select-choose-text-no-product">
                                                How bad is the damage to <br className="glassclaims-newline"/>the glass
                                            </div>
                                            <div className="ssp-dropdown-icon"></div>
                                        </div>
                                    }
                                </Dropdown.Toggle>
                                <Dropdown.Menu title="How bad is the damage to the glass">
                                    {glassDamageDrop}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                    <div className="col nopa">
                        <p className="text-16"><b>Glass repairs location</b></p>
                        <p className="font-weight-500 mb-0px">Where would you like us to repair your glass? (Psst we can
                            even come to your house!)</p>
                    </div>
                </div>
                <div className="row noma glassclaims-no-journey ">
                    <div className="col-12 nopa">
                        <div id="GoogleMap">
                            <div>
                                <PlacesAutocomplete
                                    value={this.state.adressSelect}
                                    onChange={this.handleAdressChange}
                                    onSelect={this.handleAdressSelect}
                                    searchOptions={{componentRestrictions: {country: countryFilter}}}
                                >
                                    {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                                        <div className="position-relative">
                                            <input
                                                {...getInputProps({
                                                    placeholder: 'Find repair address...',
                                                    className: ' ssp-autocomplete-searchbox',
                                                })}
                                            />
                                            <div
                                                className={(suggestions.length > 0 ? 'ssp-autocomplete-dropdown-container' : 'd-none')}>
                                                {loading && <div className="ssp-autocomplete-loading">Loading...</div>}
                                                {suggestions.map(suggestion => {
                                                    const className = 'ssp-autocomplete-suggestion-item';
                                                    return (
                                                        <>
                                                            <div
                                                                {...getSuggestionItemProps(suggestion, {
                                                                    className,
                                                                })}
                                                            >
                                                                <span
                                                                    className="ssp-autocomplete-suggestion-actual">{suggestion.description}</span>
                                                            </div>
                                                            <div className="ssp-autocomplete-hr-container">
                                                                <hr className="ssp-autocomplete-hr-divider"/>
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </PlacesAutocomplete>
                            </div>
                            <div className="ssp-googlemap-holder">
                                <Map google={this.props.google}
                                     centerAroundCurrentLocation
                                     center={{lat: this.state.lat, lng: this.state.lng}}
                                     onReady={this.mapReady}
                                     containerStyle={{
                                         position: 'relative',
                                         overflow: 'hidden',
                                         width: '100%',
                                         height: '100%',
                                         borderRadius: '8px'
                                     }}>
                                    <Marker
                                        // @ts-ignore
                                        position={{lat: this.state.lat, lng: this.state.lng}}
                                        draggable={false}
                                        title="Accident location"
                                    />
                                </Map>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetFNOLLocation: (WhereDescription, Address, AddressLat, AddressLon) => dispatch(setFNOLLocation(WhereDescription, Address, AddressLat, AddressLon)),
        dispatchSetHasSmashAndGrab: (value) => dispatch(setHasSmashAndGrab(value)),
        dispatchSetCanBeenRepaired: (value) => dispatch(setCanBeenRepaired(value)),
        dispatchSetRepairStepValid: (value) => dispatch(setRepairStepValid(value)),
        dispatchAction: (e) => dispatch(e),
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps)(GlassRepairsNo)

export default GoogleApiWrapper({
    apiKey: 'AIzaSyA-H0lUISGUeL7ipjcqTTwK3gmMaSZynR8'
})(connector);